import { MenuItem, Select } from "@mui/material";
import Grid from "@mui/material/GridLegacy";
import CharsLimitedTextField from "components/CharsLimitedTextField";
import DateSelect from "components/DateSelect";
import LanguageSelect from "components/LanguageSelect";
import { DateTime } from "luxon";
import { useEffect } from "react";
import useScriptManagementStore from "../hooks/useScriptManagementStore";
import useFormHelpers from "./hooks/useFormHelpers";

const MAX_TITLE = 200;
const MAX_DESCRIPTION = 255;

export default function ScriptDetails() {
  const { script, handleUpdateScript, setHasScriptError } =
    useScriptManagementStore();
  const { scriptTypes } = useFormHelpers();

  function updateStartDate(startDate: string) {
    handleUpdateScript("startDate", startDate);
  }

  function updateEndDate(startDate: string) {
    handleUpdateScript("endDate", startDate);
  }

  useEffect(() => {
    setHasScriptError(
      script.title.length > MAX_TITLE ||
        script.description.length > MAX_DESCRIPTION,
    );
  }, [script]);

  return (
    <Grid container rowSpacing={1}>
      <Grid item xs={12} sm={6}>
        <Select
          value={script.type}
          onChange={(event) => {
            handleUpdateScript("type", event.target.value);
          }}
        >
          {scriptTypes.map((type, index) => (
            <MenuItem key={`item-${index}`} value={type.id}>
              {type.name}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      <Grid item xs={12}>
        <CharsLimitedTextField
          maxChars={MAX_TITLE}
          label={"Title *"}
          onChange={(event) => {
            handleUpdateScript("title", event.target.value);
          }}
          multiline={true}
          rows={3}
          value={script.title}
        />
      </Grid>
      <Grid item xs={12}>
        <CharsLimitedTextField
          maxChars={MAX_DESCRIPTION}
          label={"Description *"}
          onChange={(event) => {
            handleUpdateScript("description", event.target.value);
          }}
          multiline={true}
          rows={3}
          value={script.description}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <LanguageSelect
          languageCode={script.languageCode}
          label="Language Spoken"
          onChange={(value) => handleUpdateScript("languageCode", value)}
        />
      </Grid>
      {script.type === "MOBILE" && (
        <Grid item container spacing={2} xs={12}>
          <Grid item xs={6}>
            <DateSelect
              defaultDate={DateTime.fromISO(script.startDate)}
              label="Start Date"
              customError="Invalid Start Date"
              minDate={DateTime.fromISO(script.startDate) || DateTime.now()}
              onChange={updateStartDate}
              onError={setHasScriptError}
            />
          </Grid>
          <Grid item xs={6}>
            <DateSelect
              defaultDate={DateTime.fromISO(script.endDate)}
              label="End Date"
              customError="Invalid End Date"
              minDate={
                script.startDate
                  ? DateTime.fromISO(script.startDate).plus({ days: 1 })
                  : DateTime.now().plus({ days: 1 })
              }
              onChange={updateEndDate}
              onError={setHasScriptError}
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
